import { createActionTypes } from "@helpers/redux-helpers";

export const getPolicySettingsActionTypes =
  createActionTypes("policySettings/get");

export const updatePolicySettingsActionTypes = createActionTypes(
  "policySettings/update",
);

export const clearPolicySettingsActionTypes = createActionTypes(
  "policySettings/clearStates",
);
